import CircleStencil from "./CircleStencil";

export default CircleStencil;